/**
 * Les codes à quatre chiffres des liens sans compte (présences des plaines, pointage de la
 * garderie) : ce que les écrans disent des codes faux (migration
 * `20261103120000_les_codes_ralentis`).
 *
 * Deux compteurs dans la base : les codes faux **d'affilée** (un bon code les efface) font,
 * à partir du 5e, une pause de 1, 2, 4, 8, puis 15 min au plus, pendant laquelle le lien
 * répond `lien_ralenti:<secondes>` à tout appel ; le **total** des codes faux sur la vie du
 * lien (`essais_code`, qu'aucun bon code n'efface) le bloque au 30e.
 */

export const CODES_FAUX_AVANT_BLOCAGE = 30;

/** Les secondes d'attente d'un refus `lien_ralenti:<secondes>`, ou `null` pour un autre refus. */
export function attenteDuRefus(message: string): number | null {
  const m = /lien_ralenti:(\d+)/.exec(message);
  return m ? Number(m[1]) : null;
}

/**
 * « Ce lien est en pause après trop de codes faux : réessayez dans 3 minutes. » — à la minute
 * supérieure, une au moins. Le message ne vise pas la personne : un animateur qui a le bon code
 * le voit aussi quand quelqu'un d'autre a tapé des codes faux.
 */
export function messageDAttente(secondes: number): string {
  const minutes = Math.max(1, Math.ceil(secondes / 60));
  return `Ce lien est en pause après trop de codes faux : réessayez dans ${minutes === 1 ? 'une minute' : `${minutes} minutes`}.`;
}

/** Pour Gestion : ce que le total des codes faux d'un lien veut dire, ou `null` s'il est à zéro. */
export function etatDesCodesFaux(essais: number): string | null {
  if (essais <= 0) return null;
  if (essais >= CODES_FAUX_AVANT_BLOCAGE) return `bloqué après ${essais} codes faux : recréez le lien`;
  return `${essais} code${essais > 1 ? 's' : ''} faux (blocage à ${CODES_FAUX_AVANT_BLOCAGE})`;
}
